import { FeatureIconName } from "../types";

export const FeatureIcon = ({ name }: { name: FeatureIconName }) => {
  if (name === "clock") {
    return (
      <svg className="feature-icon" viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.5">
        <circle cx="16" cy="16" r="13" />
        <path d="M16 9v7l5 3" />
      </svg>
    );
  }

  if (name === "check") {
    return (
      <svg className="feature-icon" viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.5">
        <circle cx="16" cy="16" r="13" />
        <path d="M11 16l4 4 6-7" />
      </svg>
    );
  }

  if (name === "card") {
    return (
      <svg className="feature-icon" viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.5">
        <rect x="4" y="6" width="24" height="20" rx="2" />
        <path d="M4 12h24M10 18h4M10 22h6" />
      </svg>
    );
  }

  if (name === "star") {
    return (
      <svg className="feature-icon" viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M16 4l3 9h9l-7 5 3 9-8-6-8 6 3-9-7-5h9z" />
      </svg>
    );
  }

  if (name === "chart") {
    return (
      <svg className="feature-icon" viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M6 20l4-4 4 4 4-6 4 3 4-5" />
        <rect x="3" y="5" width="26" height="22" rx="1" />
      </svg>
    );
  }

  return (
    <svg className="feature-icon" viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.5">
      <circle cx="16" cy="10" r="5" />
      <path d="M6 28c0-5.523 4.477-10 10-10s10 4.477 10 10" />
      <path d="M21 20l3 3-3 3" />
    </svg>
  );
};
